import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { anchorIsNakedNewsLive } from '../../../utils/helpers';


const MESSAGES = {
  LIVE_SHOW: 'Only subscribers can watch this show',
  GROUP_SHOW: 'Only subscribers can watch this party show',
  SPOTLIGHT: 'Only subscribers can watch this spotlight show',
  TULUM_EVENT: 'Only subscribers can enjoy Naked & Uncut!',
};

function LiveFeedCTAMessage(props) {
  const {
    showLiveShowOverlay,
    showGroupShowOverlay,
    showSpotlightOverlay,
    isTulumRealityShow,
    canSubscribeToAnchor,
    isBanned,
    anchorId,
    slug,
    user,
    spotlighterClosedSession,
  } = props;

  const getSubscriptionCTAMessage = useCallback(() => {
    if (isTulumRealityShow) {
      return MESSAGES.TULUM_EVENT;
    }

    if (showSpotlightOverlay) {
      return MESSAGES.SPOTLIGHT;
    }

    if (showGroupShowOverlay) {
      return MESSAGES.GROUP_SHOW;
    }

    if (showLiveShowOverlay) {
      return MESSAGES.LIVE_SHOW;
    }

    return MESSAGES.LIVE_SHOW;
  }, [showLiveShowOverlay, showGroupShowOverlay, showSpotlightOverlay, isTulumRealityShow]);
  const showEndedForLoggedInUser = user?.authenticated && ((spotlighterClosedSession && showSpotlightOverlay) ||
    (spotlighterClosedSession && showLiveShowOverlay));

  const disableOverlayForRealityShow = !isTulumRealityShow && !canSubscribeToAnchor && !anchorIsNakedNewsLive(anchorId);
  const shouldNotShowOverlayForShow = !showLiveShowOverlay && !showGroupShowOverlay && !showSpotlightOverlay;
  const userHasAnchorRole = user?.user?.account?.anchor;

  if (disableOverlayForRealityShow || showEndedForLoggedInUser || shouldNotShowOverlayForShow || userHasAnchorRole) {
    return null;
  }

  return (
    <div className="anchor-video-player-subscribe-overlay">
      <div
        className={classnames(
          'anchor-video-player-subscribe-message', { 'tulum-event': isTulumRealityShow })}
      >
        <p>{getSubscriptionCTAMessage()}</p>
        {!isBanned &&
          <Link
            className="btn btn-red btn-lg btn-curved"
            to={`/account/purchase?_anchor=${anchorId}&_shortUrl=${slug}`}
          >
            Subscribe
          </Link>}
      </div>
    </div>
  );
}

export default LiveFeedCTAMessage;
